/*
 * SmartHome-Energy — Vorkasse ab 4.000 € (03.10.2026)
 *
 * Laut Versandbedingungen gilt ab einem Bestellwert von 4.000 € nur Vorkasse
 * per Banküberweisung. Der Checkout selbst ist auf dem Basic-Plan nicht
 * anpassbar, deshalb setzt dieses Skript die Regel im Theme so weit wie möglich um:
 *
 *  - Warenkorbseite, Theme-Drawer und Header-Drawer (she-header): Hinweisbox
 *    über dem Checkout-Button, sobald cart.total_price >= 4.000 €.
 *  - Express-Buttons (PayPal, Apple Pay, Google Pay, Shop Pay) im Warenkorb
 *    werden dann ausgeblendet (Klasse she-vk-over am <html>).
 *  - Produktseite: Der „Sofort kaufen“-Button wird ausgeblendet, wenn
 *    Variantenpreis × Menge >= 4.000 € ergibt.
 *
 * Bestellwert = cart.total_price (inkl. MwSt., nach Rabatten, ohne Versand).
 * Grenze ändern: LIMIT unten (in Cent). Die Nachkontrolle macht Shopify Flow.
 */
(function () {
  if (window.__sheVorkasse) return;
  window.__sheVorkasse = true;

  var LIMIT = 400000; // Cent
  var POLICY = '/policies/shipping-policy';
  var total = null;
  var product = null;

  var css =
    '.she-vk{display:flex;gap:10px;align-items:flex-start;margin:0 0 12px;padding:12px 14px;' +
    'border:1px solid #f0c36d;border-left:4px solid #e0a100;background:#fff8e6;color:#3d2e00;' +
    'border-radius:8px;font-size:13.5px;line-height:1.45;text-align:left}' +
    '.she-vk svg{flex:0 0 20px;width:20px;height:20px;margin-top:1px;color:#b57f00}' +
    '.she-vk a{color:inherit;text-decoration:underline}' +
    '.she-vk--pdp{margin:12px 0 0}' +
    'html.she-vk-over .dynamic-cart-btns,' +
    'html.she-vk-over shopify-accelerated-checkout-cart,' +
    'html.she-vk-over .additional-checkout-buttons{display:none!important}' +
    '.she-vk-hide{display:none!important}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="10"/><path d="M12 7v6M12 16.5v.5"/></svg>';
  var TXT =
    '<div><strong>Ab 4.000 € Bestellwert nur Vorkasse per Banküberweisung.</strong> ' +
    'Bitte wähle im Checkout die Zahlungsart <strong>Banküberweisung</strong>. ' +
    'Andere Zahlungsarten können wir ab diesem Betrag nicht annehmen ' +
    '(<a href="' + POLICY + '">Versandbedingungen</a>).</div>';
  var TXT_PDP =
    '<div>Ab 4.000 € Bestellwert ist nur <strong>Vorkasse per Banküberweisung</strong> möglich. ' +
    'Bitte über <strong>In den Warenkorb</strong> bestellen.</div>';

  function box(pdp) {
    var d = document.createElement('div');
    d.className = 'she-vk' + (pdp ? ' she-vk--pdp' : '');
    d.setAttribute('data-she-vk', pdp ? 'pdp' : 'cart');
    d.setAttribute('role', 'note');
    d.innerHTML = ICON + (pdp ? TXT_PDP : TXT);
    return d;
  }

  /* Wo die Box hinkommt: jeweils direkt vor dem Checkout-Bereich. */
  function targets() {
    var out = [];
    // Theme-Drawer: Container mit allen Checkout-Buttons
    document.querySelectorAll('.cart-drawer__checkout-buttons').forEach(function (el) {
      out.push({ parent: el, before: el.firstElementChild });
    });
    // Warenkorbseite: Wrapper (div.mt-6) des Checkout-Buttons in der Zusammenfassung
    document.querySelectorAll('button[name="checkout"]').forEach(function (b) {
      if (b.closest('.cart-drawer__checkout-buttons')) return;
      var wrap = b.parentElement;
      if (wrap && wrap.parentElement) out.push({ parent: wrap.parentElement, before: wrap });
    });
    // Header-Drawer (she-header): vor „Zum Warenkorb“ / „Zur Kasse“
    document.querySelectorAll('[data-shx-cart-foot]').forEach(function (f) {
      out.push({ parent: f, before: f.querySelector('.shx-btn') });
    });
    return out;
  }

  function applyCart() {
    var over = total !== null && total >= LIMIT;
    var root = document.documentElement;
    if (root.classList.contains('she-vk-over') !== over) root.classList.toggle('she-vk-over', over);

    if (!over) {
      document.querySelectorAll('[data-she-vk="cart"]').forEach(function (n) { n.remove(); });
      return;
    }
    targets().forEach(function (t) {
      if (t.parent.querySelector(':scope > [data-she-vk="cart"]')) return;
      t.parent.insertBefore(box(false), t.before && t.before.parentNode === t.parent ? t.before : null);
    });
  }

  /* Produktseite: „Sofort kaufen“ kauft nur diesen Artikel, am Warenkorb vorbei. */
  function applyProduct() {
    if (!product) return;
    document.querySelectorAll('.product-info__dynamic-checkout-button').forEach(function (btns) {
      var form = btns.closest('form');
      if (!form) return;
      var idEl = form.querySelector('[name="id"]');
      var qEl = form.querySelector('[name="quantity"]');
      var vid = idEl ? parseInt(idEl.value, 10) : NaN;
      var qty = qEl ? Math.max(1, parseInt(qEl.value, 10) || 1) : 1;
      var v = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id === vid) { v = product.variants[i]; break; }
      }
      var over = !!v && v.price * qty >= LIMIT;
      if (btns.classList.contains('she-vk-hide') !== over) btns.classList.toggle('she-vk-hide', over);
      var note = btns.parentNode.querySelector(':scope > [data-she-vk="pdp"]');
      if (over && !note) btns.parentNode.insertBefore(box(true), btns.nextSibling);
      if (!over && note) note.remove();
    });
  }

  function apply() {
    applyCart();
    applyProduct();
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { total = c.total_price; apply(); })
      .catch(function () {});
  }

  /* Jede Warenkorb-Änderung (Theme, Header-Drawer, Meterware-Stepper) läuft über fetch. */
  var CHANGE = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  function isChange(url) {
    for (var i = 0; i < CHANGE.length; i++) if (url.indexOf(CHANGE[i]) > -1) return true;
    return false;
  }
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input) {
      var p = _fetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (isChange(url)) p.then(function () { setTimeout(refresh, 60); });
      } catch (e) {}
      return p;
    };
  }

  /* Drawer und Warenkorb werden bei Änderungen neu gerendert -> Box wieder einsetzen. */
  var t = null;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(apply, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('change', function (e) {
    if (e.target && (e.target.name === 'quantity' || e.target.name === 'id')) setTimeout(applyProduct, 50);
  });
  document.addEventListener('input', function (e) {
    if (e.target && e.target.name === 'quantity') applyProduct();
  });

  function loadProduct() {
    if (!document.querySelector('.product-info__dynamic-checkout-button')) return;
    var path = location.pathname;
    if (path.slice(-1) === '/') path = path.slice(0, -1);
    if (path.indexOf('/products/') === -1) return;
    fetch(path + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { product = p; applyProduct(); })
      .catch(function () {});
  }

  function init() { refresh(); loadProduct(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
